// ----------------------------------------------------------------------

export const JWT_STORAGE_KEY = 'jwt_access_token';

export const REFRESH_TOKEN_STORAGE_KEY = 'jwt_refresh_token';
